
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface ActiveToggleProps {
  isActive: boolean;
  onChange: (isActive: boolean) => void;
}

export default function ActiveToggle({
  isActive,
  onChange,
}: ActiveToggleProps) {
  return (
    <div className="grid grid-cols-4 items-center gap-4">
      <Label htmlFor="active" className="text-right">
        Ativo
      </Label>
      <div className="flex items-center space-x-2 col-span-3">
        <Switch
          id="active"
          checked={isActive}
          onCheckedChange={(checked) => onChange(checked)}
        />

      </div>
    </div>
  );
}
